import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client';
import App from './App'
import reportWebVitals from './reportWebVitals'
// import { Provider } from 'react-redux'
// import { store } from './redux/store'
// import i18n from './i18n'
// import { I18nextProvider } from 'react-i18next'
// import { PersistGate } from 'redux-persist/integration/react';
// import persistStore from 'redux-persist/es/persistStore';

// let persistor = persistStore(store);

const root = createRoot(document.getElementById('root'))
root.render(
  // <Provider store={store}>
  //   <PersistGate loading={null} persistor={persistor}>
  //     <I18nextProvider i18n={i18n}>
        <App />
  //     </I18nextProvider>
  //   </PersistGate>
  // </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
